
ProgramColumns = [{
    name: 'placement', label: 'Placement in PSE', num: 'placed', denom: 'students',
    num_desc: 'students placed in PSE.', denom_desc: 'students exited.'
}, {
    name: 'fafsa', label: 'Completed FAFSA', num: 'fafsa_yes', denom: 'students',
    num_desc: 'students completed FAFSA.', denom_desc: 'students exited.'
}, {
    name: 'applications', label: 'Completed PSE Applications', num: 'applications_yes', denom: 'applications_known',
    num_desc: 'students completed PSE applicaitons.', denom_desc: 'students with known answer.'
}, {
    name: 'test', label: 'Took PSE Placement Tests', num: 'test_yes', denom: 'test_known',
    num_desc: 'students took PSE placement tests.', denom_desc: 'students with known answer.'
}, {
    name: 'credits', label: 'Earned PSE Credits', num: 'credits_yes', denom: 'credits_known',
    num_desc: 'students earned PSE credits.', denom_desc: 'students with known answer.'
}, {
    name: 'goal_entry', label: 'PSE Goal at Entry', num: 'goal_entry_yes', denom: 'goal_entry_known',
    num_desc: 'students desired a degree at entry', denom_desc: 'students with known answer.'
}, {
    name: 'goal_exit', label: 'PSE Goal at Exit', num: 'goal_exit_yes', denom: 'goal_exit_known',
    num_desc: 'students desired a degree at exit.', denom_desc: 'students with known answer.'
}]


StudentColumns = [{
    name: 'completed_fafsa', num: 'fafsa_yes', denom: 'students'
    num_desc: 'students completed FAFSA.', denom_desc: 'students exited.'
}, {
    name: 'pse_credits_count', num: 'credits_yes', denom: 'credits_known'
    num_desc: 'students earned PSE credits.', denom_desc: 'students with known answer.'
}, {
    name: 'pse_placement_test', num: 'test_yes', denom: 'test_known'
    num_desc: 'students took PSE placement tests.', denom_desc: 'students with known answer.'
}, {
    name: 'pse_applications', num: 'applications_yes', denom: 'applications_known'
    num_desc: 'students completed PSE applicaitons.', denom_desc: 'students with known answer.'
}, {
    name: 'entry_desired_credential', num: 'goal_entry_yes', denom: 'goal_entry_known'
    num_desc: 'students desired a degree at entry', denom_desc: 'students with known answer.'
}, {
    name: 'exit_desired_credential', num: 'goal_exit_yes', denom: 'goal_exit_known'
    num_desc: 'students desired a degree at exit.', denom_desc: 'students with known answer.'
}]

psePrepReportStates = ($stateProvider, TagUrl) ->
    'ngInject'

    url = new TagUrl()
        .addTagTypes(['program', 'location', 'participant'])
        .setTagDefault('affiliation', 'all')
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    $stateProvider.state 'reports.psePrep',
        url: url.buildUrl('/pse-prep')
        params: url.params
        data: tagUrl: url
        reloadOnSearch: false
        templateUrl: 'reports/psePrep/programs'
        controller: 'PsePrepReportController'
        controllerAs: '$ctrl'
        resolve:
            program: () -> null
            dataLoader: resolvePsePrepReportDataLoader
            columns: () -> ProgramColumns

    programUrl = new TagUrl()
        .addTagTypes(['participant'])
        .addExtraParam('page', {type: 'int', value: 1, squash: true})
        .addExtraParam('sort', 'name')

    $stateProvider.state 'program.reports.psePrep',
        url: programUrl.buildUrl('/pse-prep')
        params: programUrl.params
        data: tagUrl: programUrl
        reloadOnSearch: false
        templateUrl: 'reports/psePrep/students'
        controller: 'PsePrepReportController'
        controllerAs: '$ctrl'
        resolve:
            columns: () -> StudentColumns
            dataLoader: resolvePsePrepReportDataLoader



resolvePsePrepReportDataLoader = ($http, $timeout, $state, ApiUrl, program) ->
    'ngInject'

    timeoutPromise = null
    baseUrl = ApiUrl.partial('reports', 'pse-prep')
    url = if program then baseUrl(program.id) else baseUrl()

    return (tags, sort, page) ->
        $timeout.cancel(timeoutPromise)
        getData = () ->
            params = angular.extend {}, tags,
                sort: sort
                page: page

            $state.go '.', params, location: 'replace'

            return $http.get(url, params: params).then (result) ->
                return result.data

        timeoutPromise = $timeout getData, 100
        return timeoutPromise


class PsePrepReportController

    ### @ngInject ###
    constructor: ($scope, $stateParams, @dataLoader, @columns) ->

        @loading = true
        @tags = undefined
        @sort = $stateParams.sort or 'name'
        @page = $stateParams.page or 1

        $scope.$watch '$ctrl.pager.page', @onPageChange

    reloadData: () ->
        @loading = true
        @dataLoader(@tags, @sort, @page).then (data) =>
            @loading = false
            @items = data.items
            @totals = data.totals
            @maximums = data.maximums
            @pager = data.pager

    tagChange: (tags) ->
        if angular.equals(tags, @tags) then return
        @page = 1 if angular.isDefined(@tags)
        @tags = tags
        @reloadData()

    onPageChange: (page) =>
        if not page or page == @page then return
        @page = page
        @reloadData()

    onSortChange: () ->
        @reloadData()


module.config psePrepReportStates
module.controller 'PsePrepReportController', PsePrepReportController
